import styled, { css } from 'styled-components';

const fullscreenStyles = css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;

export const Container = styled.div`
    ${fullscreenStyles};
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 99;
`;

export const Backdrop = styled.div`
    ${fullscreenStyles};
    background: ${({ theme }) => theme.colors.modalBackdrop};
    opacity: 0.48;
    z-index: 1;
`;

export const ContentContainer = styled.div`
    width: 33rem;
    background: white;
    border-radius: 8px;
    z-index: 2;
`;

export const Title = styled.div`
    padding: 2rem;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.33333334;
    border-bottom: 1px solid ${({ theme }) => theme.colors.lightShadow};
`;

export const Body = styled.div`
    padding: 1rem 2rem;
`;

export const Footer = styled.div`
    padding: 1rem;
    border-top: 1px solid ${({ theme }) => theme.colors.lightShadow};
`;
